import zh from './locales/zh.js';

export function t(key, params = {}) {
  let str = zh[key] ?? key;
  Object.entries(params).forEach(([k, v]) => {
    str = String(str).replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), v);
  });
  return str;
}

export function useTranslation() {
  return { t, i18n: { language: 'zh', changeLanguage: () => Promise.resolve() } };
}
